module.exports = __webpack_public_path__ + "img/brave.1a002252.webp";